<template>
  <div class="results-choice-step">
    <div class="results-choice-content">
      <!-- Content Section -->
      <div class="content-section">
        <!-- Image -->
        <div class="image-container">
          <img
            :src="imageUrl"
            alt="Результаты вашего стиля готовы"
            class="results-image"
          />
        </div>

        <!-- Text Block -->
        <div class="text-block">
          <h2 class="step-title">{{ step.title }}</h2>
          <p v-if="step.subtitle" class="step-subtitle">{{ step.subtitle }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useTasteClarificationModal } from '@/features/taste/store'
import type { TasteStep } from '@/features/taste/types/taste-config'

interface Props {
  step: TasteStep & { type: 'choice' }
}

const props = defineProps<Props>()
const tasteStore = useTasteClarificationModal()

const imageUrl = '/img/avatar-taste.png' // Placeholder, нужно будет заменить на реальное изображение
</script>

<style scoped>
.results-choice-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 100%;
}

.results-choice-content {
  max-width: 1020px;
  width: 100%;
}

.content-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
  padding: 40px 120px;
}

.image-container {
  flex-shrink: 0;
  width: 234px;
  height: 234px;
}

.results-image {
  width: 234px;
  height: 234px;
  border-radius: 20px;
  object-fit: cover;
}

.text-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.step-title {
  font-family: Gilroy, sans-serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.04em;
  color: #232F45;
  margin: 0;
  text-align: left;
}

.step-subtitle {
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.3;
  letter-spacing: -0.04em;
  color: rgba(35, 47, 69, 0.8);
  margin: 0;
  text-align: left;
}


@media (min-width: 1920px) {
  .results-choice-step {
    padding:0;
  }

  .content-section {
    padding: 40px 120px;
    gap: 40px;
  }

  .image-container {
    width: 234px;
    height: 234px;
  }

  .results-image {
    width: 234px;
    height: 234px;
  }

  .step-title {
    font-size: 48px;
    line-height: 1.2;
  }

  .step-subtitle {
    font-size: 20px;
    line-height: 1.3;
  }
}

@media (min-width: 1440px) and (max-width: 1919px) {


  .content-section {
    padding: 40px;
  }
 }

@media (min-width: 1024px) and (max-width: 1439px) {
  .content-section {
    flex-direction: column;
    padding: 40px 60px;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .results-choice-step {
    padding: 0;
  }

  .content-section {
    display: flex;
    padding: 0 var(--Padding-XL, 20px) var(--Padding-XL, 20px) var(--Padding-XL, 20px);
    flex-direction: column-reverse;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 0;
    align-self: stretch;

  }

  .text-block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--Spacing-S, 8px);
    align-self: stretch;
  }

  .step-title {
    color: var(--Color-Primary-blue-100, #232F45);
    font-variant-numeric: ordinal;
    font-feature-settings: 'case' on, 'liga' off;

    /* FAIR Typography/App/H1-bold */
    font-family: Gilroy;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 109%; /* 34.88px */
    letter-spacing: -0.64px;
  }

  .step-subtitle {
    color: var(--Color-Primary-blue-80, rgba(35, 47, 69, 0.80));
    font-variant-numeric: ordinal;
    font-feature-settings: 'case' on;

    /* FAIR Typography/App/Body-big */
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%; /* 20.8px */
    letter-spacing: -0.64px;
   }
}

@media (min-width: 393px) and (max-width: 767px) {
  .results-choice-step {
    padding: 0;
  }

  .content-section {
    display: flex;
    padding: 0 var(--Padding-XL, 20px) var(--Padding-XL, 20px) var(--Padding-XL, 20px);
    flex-direction: column-reverse;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 0;
    align-self: stretch;

  }

  .text-block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--Spacing-S, 8px);
    align-self: stretch;
  }

  .step-title {
    color: var(--Color-Primary-blue-100, #232F45);
    font-variant-numeric: ordinal;
    font-feature-settings: 'case' on, 'liga' off;

    /* FAIR Typography/App/H1-bold */
    font-family: Gilroy;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 109%; /* 34.88px */
    letter-spacing: -0.64px;
  }

  .step-subtitle {
    color: var(--Color-Primary-blue-80, rgba(35, 47, 69, 0.80));
    font-variant-numeric: ordinal;
    font-feature-settings: 'case' on;

    /* FAIR Typography/App/Body-big */
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%; /* 20.8px */
    letter-spacing: -0.64px;
   }
}

</style>





